/**
 * Created by OLD on 06/08/2015.
 */
define('myWebSiteMain',[
  'module',
  'logger',
  'myWebSiteMainRouter'
], function(
  module,
  Logger
) {
	'use strict';
	
  var MyWebSite = {
    start: function() {
      Logger.log(module, 'starting MyWebSiteModule');
    },

    stop: function() {
      Logger.log(module, 'stopping MyWebSiteModule');
    }
  };

  module.exports = MyWebSite;
});
